import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.styles.css';
import useWindowSize from '../../hooks/useWindowSize';
import { useSelector } from 'react-redux';
import FlagComponent from '../flag/Flag.component';

const Footer = () => {
    const { t, i18n } = useTranslation();
    const windowSize = useWindowSize();
    const env = useSelector(state => state?.env);

    const d = useMemo(() => new Date(), []);

    const renderFooterNumbers = () => {
        if(env?.candFooterNumbers && env?.candFooterNumbers?.length > 0) {
            return env?.candFooterNumbers.map(el => {
                return <div className={`d-flex align-items-center ${el?.flagClass ? 'pe-4' : ''}`}>
                    {el?.flagClass && <FlagComponent countryCode={el.flagClass} />}
                    <span className='ps-2 cm-xs-txt text-blue-500 fw-medium'><a href={el.link}>{el.label}</a></span>
                </div>
            })
        } else {
            return null;
        }
    }

    return(
        <footer className={`cm-footer-container bg-white px-4 py-3 d-flex ${windowSize.isMobile ? "justify-content-center" : "justify-content-between"} align-items-center flex-wrap`}>
            <p className={`${windowSize.isMobile ? "mb-2" : "mb-0"} px-2 cm-xs-txt fw-medium text-blue-gray-500`}>Marsh © 2010-{d.getFullYear()}, {t("all_rights_reserved")}</p>
            <div className="px-2 cm-footer-support-wrap d-flex align-items-center">
                {i18n.exists("footer_ph_num_helper_txt") && t("footer_ph_num_helper_txt") !== "null_key" && <p className={`mb-0 ${windowSize.isMobile ? "" : "pe-4"}  cm-xs-txt text-blue-gray-500 fw-medium`}>{t("footer_ph_num_helper_txt")}</p>}
                <div className="cm-ph-num-wrapper d-flex align-items-center flex-wrap">
                    {renderFooterNumbers()}
                </div>
            </div>
        </footer>
    )

}

export default Footer;